import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/query-keys'
import { templatesService } from '@/api/services/templates.service'

export function useTemplateKeywordsQuery(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.templates.keywords(),
    queryFn: () => templatesService.getTemplateKeywords(),
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
